import React, { useState, useEffect, useRef } from 'react';

import PropTypes from 'prop-types';

import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';

import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import { default as StyledTimePicker } from 'rc-time-picker';

import {
    Text,
    CircleArrowRight,
    BulletIcon,
    LineIcon,
    FacebookIcon,
    InstagramIcon,
    YoutubeIcon,
    IconButton,
    HorizontalRule,
    Span,
    CallIcon,
    SMSIcon,
    CalendarIcon2,
    TimeIcon,
    PhoneFormat,
    ContainedButton,
    OutlinedButton,
    StyledCard,
    ListIcon,
} from '../index';

import {
    StyledPageLayout,
    StyledTitleGradient,
    StyledButton,
    StyledHeaderContainer,
    StyledNavContainer,
    StyledBlurButton,
    StyledBlackButton,
    StyledStartSectionContainer,
    StyledStartContainer,
    StyledStartExampleContainer,
    StyledInfoSectionContainer,
    StyledInfoContainer,
    StyledInfoImageContainer,
    StyledFunctionSectionContainer,
    StyledFunctionImageContainer,
    StyledFunctionContainer,
    StyledFunctionInfoTextGroup,
    StyledFunctionInfoTextContainer,
    StyleProfile,
    StyledProfressonalSectionContainer,
    StyledProfressonalTitleContainer,
    StyledProfressonalAvatarContainer,
    StyledAvatarContainer,
    StyledWhySectionContainer,
    StyledWhyCardContainer,
    StyledWhyCard,
    StyledIcon,
    StyledJoinSectionContainer,
    StyledTicketCard,
    StyledTicketButton,
    StyledJoinTextContainer,
    StyledStartSectionTwo,
    StyledMaskContainer,
    StyledFooterContainer,
    StyledButtonNavContainer,
    StyledButtonContainer,
    StyledPlanSectionContainer,
    StyledPlanCardContainer,
    StyledPlanCard,
    StyledCardItem,
    CardItemContainer,
    StyledPlanButton,
    HalfBackground,
    StyledBookSectionContainer,
    StyledBookFormCard,
    StyledInput,
    StyledKeyboardDatePicker,
    StyledBookSuccessContainer,
    StyledStartExampleColumn,
    StyledToolBar,
} from './style';

const FirdayLogo1 = '/resources/images/landingPage/landing_page_logo.svg';
const FirdayLogo2 = '/resources/images/friday_logo.svg';
const MaskBackground = '/resources/images/landingPage/mask.png';
const Example2 = '/resources/images/landingPage/example_2.svg';
const Example3 = '/resources/images/landingPage/example_3.svg';
const Example4 = '/resources/images/landingPage/example_4.svg';
const Export_logo = '/resources/images/landingPage/export_logo.svg';
const Image1 = '/resources/images/landingPage/image_1.png';
const Image2 = '/resources/images/landingPage/image_2.png';
const Image3 = '/resources/images/landingPage/image_3.png';
const LineChart = '/resources/images/landingPage/line_chart_2.gif';
const CircleChart = '/resources/images/landingPage/circle_chart.gif';
const Radar = '/resources/images/landingPage/radar.svg';
const Profile = '/resources/images/landingPage/profile.svg';
const Avatar1 = '/resources/images/landingPage/avatar_1.svg';
const Avatar2 = '/resources/images/landingPage/avatar_2.svg';
const Avatar3 = '/resources/images/landingPage/avatar_3.svg';
const Avatar4 = '/resources/images/landingPage/avatar_4.svg';
const Avatar5 = '/resources/images/landingPage/avatar_5.svg';
const Avatar6 = '/resources/images/landingPage/avatar_6.svg';
const Avatar7 = '/resources/images/landingPage/avatar_7.svg';
const Icon1 = '/resources/images/landingPage/icon_1.svg';
const Icon2 = '/resources/images/landingPage/icon_2.svg';
const Icon3 = '/resources/images/landingPage/icon_3.svg';
const Icon4 = '/resources/images/landingPage/icon_4.svg';
const Icon5 = '/resources/images/landingPage/icon_5.svg';
const Icon6 = '/resources/images/landingPage/icon_6.svg';
const Ticket = '/resources/images/landingPage/ticket.svg';
const Phone = '/resources/images/landingPage/phone.svg';
const commingsoonImage = '/resources/images/landingPage/commingsoon.png';

export const PageLayout = (props) => {
    const { children, ...rest } = props;

    return <StyledPageLayout {...rest}>{children}</StyledPageLayout>;
};

PageLayout.propTypes = {
    children: PropTypes.any,
};

export const BlurButton = (props) => {
    const { children, ...rest } = props;

    return <StyledBlurButton {...rest}>{children}</StyledBlurButton>;
};

BlurButton.propTypes = {
    children: PropTypes.any,
    rest: PropTypes.object,
};

export const TitleGradient = (props) => {
    const { children, ...rest } = props;

    return <StyledTitleGradient {...rest}>{children}</StyledTitleGradient>;
};

export const BlackButton = (props) => {
    const { children, ...rest } = props;
    return (
        <StyledBlackButton {...rest}>
            {children}
            <CircleArrowRight />
        </StyledBlackButton>
    );
};

BlackButton.propTypes = {
    children: PropTypes.any,
    rest: PropTypes.object,
};

export const Mask = ({ style, ...rest }) => {
    return (
        <img
            src={MaskBackground}
            alt="mask"
            style={{
                width: '100%',
                top: '0',
                left: '0',
                right: '0',
                position: 'absolute',
                ...style,
            }}
            {...rest}
        />
    );
};

Mask.propTypes = {
    style: PropTypes.object,
    rest: PropTypes.object,
};

export const Header = ({
    selectedTab,
    onSelectTab,
    handleToProvider,
    handleGoHome,
    mdUp,
    lgUp,
    xlUp,
}) => {
    const [open, setOpen] = useState(false);

    const onClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        onClose();
    }, [mdUp, lgUp, xlUp]);

    return lgUp ? (
        <StyledHeaderContainer>
            <img
                src={selectedTab === 0 ? FirdayLogo1 : FirdayLogo2}
                alt="friday"
                style={{
                    zIndex: '1',
                    height: xlUp ? '56px' : lgUp ? '50px' : '45px',
                    width: xlUp ? '78px' : lgUp ? '70px' : '62px',
                    cursor: 'pointer',
                }}
                onClick={handleGoHome}
            />

            <StyledNavContainer>
                <StyledButton onClick={() => onSelectTab(0, 'info-section')}>
                    <Text $color={selectedTab === 0 ? 'white' : 'black4'}>How It Works?</Text>
                </StyledButton>

                <StyledButton onClick={() => onSelectTab(1)}>
                    <Text $color={selectedTab === 0 ? 'white' : 'black4'}>Plan & Pricing</Text>
                </StyledButton>

                <StyledButton onClick={() => onSelectTab(2)}>
                    <Text $color={selectedTab === 0 ? 'white' : 'black4'}>
                        Book a session with us
                    </Text>
                </StyledButton>

                <BlurButton
                    style={{
                        backgroundColor:
                            selectedTab === 0
                                ? 'rgba(255, 255, 255, 0.2)'
                                : 'rgba(160, 199, 255, 0.17)',
                    }}
                    // onClick={handleToProvider}
                    onClick={() => onSelectTab(2)}
                >
                    <Text $color={selectedTab === 0 ? 'white' : 'blue11'} $fontSize="15px">
                        ลงทะเบียนเพื่อทดลองใช้ฟรี!
                    </Text>
                </BlurButton>
            </StyledNavContainer>
        </StyledHeaderContainer>
    ) : (
        <AppBar
            position="static"
            color="transparent"
            style={{
                boxShadow:
                    '0px 2px 4px -1px rgb(0 0 0 / 5%), 0px 4px 5px 0px rgb(0 0 0 / 5%), 0px 1px 10px 0px rgb(0 0 0 / 5%)',
            }}
        >
            <Drawer anchor="left" open={open} onClose={onClose}>
                <List>
                    <ListItem
                        button
                        onClick={() => {
                            onSelectTab(0, 'info-section');
                            onClose();
                        }}
                    >
                        <ListItemText primary="How It Works?" />
                    </ListItem>
                    <ListItem
                        button
                        onClick={() => {
                            onSelectTab(1);
                            onClose();
                        }}
                    >
                        <ListItemText primary="Plan & Pricing" />
                    </ListItem>
                    <ListItem
                        button
                        onClick={() => {
                            onSelectTab(2);
                            onClose();
                        }}
                    >
                        <ListItemText primary="Book a session with us" />
                    </ListItem>
                </List>
            </Drawer>
            <StyledToolBar>
                <IconButton>
                    <img
                        src={selectedTab === 0 ? FirdayLogo1 : FirdayLogo2}
                        alt="friday"
                        style={{
                            height: '35px',
                            width: '35px',
                        }}
                        onClick={handleGoHome}
                    />
                </IconButton>
                <IconButton onClick={() => setOpen(true)}>
                    <ListIcon
                        $width={'35px'}
                        $height={'35px'}
                        $color={selectedTab === 0 ? '#fff' : '#3B3955'}
                    />
                </IconButton>
            </StyledToolBar>
        </AppBar>
    );
};

Header.propTypes = {
    selectedTab: PropTypes.number,
    onSelectTab: PropTypes.func,
    handleToProvider: PropTypes.func,
};

export const StartSection = ({ handleToProvider, mdUp, lgUp, xlUp }) => {
    return (
        <StyledStartSectionContainer>
            <StyledStartContainer>
                <TitleGradient
                    style={{ textAlign: 'left', whiteSpace: 'pre' }}
                >{`FRIDAY\nbrings fine days`}</TitleGradient>
                <Text $fontSize={mdUp ? '20px' : '15px'} style={{ color: '#425466' }}>
                    สร้างระบบ Telecounseling ของคุณ
                </Text>
                <BlackButton style={{ marginTop: '15px' }} onClick={handleToProvider}>
                    <Text $fontSize={'15px'} $color="white" style={{ marginRight: '10px' }}>
                        เริ่มได้เลย
                    </Text>
                </BlackButton>
            </StyledStartContainer>
            <StyledStartExampleContainer>
                <StyledStartExampleColumn
                    style={{ rowGap: lgUp ? '25px' : mdUp ? '20px' : '15px' }}
                >
                    <img
                        src={Example2}
                        alt="example2"
                        style={{
                            width: xlUp ? '211px' : lgUp ? '180px' : mdUp ? '150px' : '120px',
                        }}
                    />
                    <StyledCard
                        style={{
                            background: '#FCFCFC',
                            padding: lgUp ? '20px 0 0 0' : mdUp ? '15px 0 0 0' : '10px 0 0 0',
                            borderRadius: '8px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                margin: lgUp ? '0 20px' : mdUp ? '0 15px' : '0 10px',
                            }}
                        >
                            <Text
                                $fontSize={lgUp ? '14px' : mdUp ? '12px' : '10px'}
                                style={{ color: '#333333' }}
                            >
                                Emotional Index
                            </Text>
                            <img
                                src={Export_logo}
                                alt="export_logo"
                                style={{ width: lgUp ? '72px' : mdUp ? '60px' : '50px' }}
                            />
                        </div>
                        <Text
                            $fontSize={lgUp ? '23px' : mdUp ? '20px' : '15px'}
                            style={{
                                color: '#333333',
                                margin: lgUp ? '0 20px' : mdUp ? '0 15px' : '0 10px',
                            }}
                        >
                            29{' '}
                            <Span
                                $fontSize={lgUp ? '12px' : mdUp ? '10px' : '8px'}
                                style={{ color: '#666666' }}
                            >
                                Participants
                            </Span>
                        </Text>
                        <img
                            src={LineChart}
                            alt="line_chart"
                            style={{
                                width: xlUp ? '300px' : lgUp ? '250px' : mdUp ? '200px' : '150px',
                            }}
                        />
                    </StyledCard>
                </StyledStartExampleColumn>
                <StyledStartExampleColumn>
                    <StyledCard
                        $backgroundColor="white"
                        style={{
                            marginTop: lgUp ? '45px' : mdUp ? '38px' : '30px',
                            borderRadius: '8px 0 0 8px',
                            paddingRight: '0px',
                            padding: lgUp
                                ? '24px 0 24px 24px'
                                : mdUp
                                ? '15px 0 15px 15px'
                                : '10px 0 10px 10px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Text
                                $fontSize={lgUp ? '14px' : mdUp ? '12px' : '10px'}
                                style={{ color: '#333333' }}
                            >
                                Emotional Summary
                            </Text>
                            <img
                                src={Export_logo}
                                alt="export_logo"
                                style={{ width: lgUp ? '72px' : mdUp ? '65px' : '50px' }}
                            />
                        </div>
                        <img
                            src={CircleChart}
                            alt="circle_chart"
                            style={{
                                width: xlUp ? '300px' : lgUp ? '250px' : mdUp ? '150px' : '125px',
                                marginTop: lgUp ? '20px' : mdUp ? '15px' : '10px',
                                marginRight: lgUp ? '20px' : mdUp ? '15px' : '10px',
                            }}
                        />
                    </StyledCard>
                    <img
                        src={Example3}
                        alt="example3"
                        style={{
                            width: xlUp ? '300px' : lgUp ? '250px' : mdUp ? '180px' : '140px',
                            marginTop: lgUp ? '20px' : mdUp ? '15px' : '10px',
                        }}
                    />
                    <img
                        src={Example4}
                        alt="example4"
                        style={{
                            width: xlUp ? '300px' : lgUp ? '250px' : mdUp ? '200px' : '120px',
                            alignSelf: 'flex-start',
                        }}
                    />
                </StyledStartExampleColumn>
            </StyledStartExampleContainer>
        </StyledStartSectionContainer>
    );
};

StartSection.propTypes = {
    handleToProvider: PropTypes.func,
};

export const InfoSection = ({ mdUp, lgUp, xlUp }) => {
    return (
        <StyledInfoSectionContainer id="info-section">
            <StyledInfoContainer>
                <Text $fontSize={mdUp ? '18px' : '14px'} $medium $color="blue11">
                    How It Works?
                </Text>
                <Text $fontSize={lgUp ? '40px' : mdUp ? '34px' : '25px'} $bold $color="black2">
                    Telecounseling Solution
                </Text>
                <Text
                    $fontSize={lgUp ? '18px' : mdUp ? '15px' : '10px'}
                    $medium
                    $color="black2"
                    style={{ marginTop: lgUp ? '30px' : mdUp ? '20px' : '10px' }}
                >
                    {`FRIDAY เป็นโซลูชั่นสำหรับพัฒนาระบบการให้บริการคำปรึกษา\nและสุขภาพจิตทางไกล`}
                </Text>
                <Text
                    $fontSize={lgUp ? '14px' : mdUp ? '12px' : '10px'}
                    style={{ color: '#656464', marginTop: mdUp ? '15px' : '10px' }}
                >
                    {`All-in-one platform ของเราเป็นสะพานเชื่อมระหว่างผู้ให้บริการและผู้รับบริการ\nด้านการปรึกษาและสุขภาพจิต ให้เข้าใกล้กันมากขึ้น ลดค่าใช้จ่ายและเวลาที่ต้อง\nเสียไปสำหรับการเดินทาง ด้วยการบริการผ่านระบบวิดีโอคอลที่ทันสมัย โดยที่คุณ\nไม่ต้องเริ่มสร้างระบบใหม่และไม่ต้องเรียนรู้เรื่อง coding`}
                </Text>
            </StyledInfoContainer>
            <StyledInfoImageContainer>
                <img src={Image1} alt="image1" />
                <div>
                    <img src={Image2} alt="image2" />
                    <img src={Image3} alt="image3" />
                </div>
            </StyledInfoImageContainer>
        </StyledInfoSectionContainer>
    );
};

export const FunctionSection = ({ mdUp, lgUp, xlUp }) => {
    return (
        <StyledFunctionSectionContainer>
            <StyledFunctionImageContainer>
                <img
                    src={Radar}
                    alt="radar"
                    style={{ width: '100%', maxWidth: lgUp ? '530px' : '270px' }}
                />
                <StyleProfile src={Profile} alt="profile" />
            </StyledFunctionImageContainer>
            <StyledFunctionContainer>
                <Text $fontSize={xlUp ? '18px' : '15px'} $color="blue11" $medium>
                    Functions & Features
                </Text>
                <Text $fontSize={xlUp ? '36px' : lgUp ? '25px' : '17px'} $color="black2" $medium>
                    {`คุณสามารถมีระบบ Telecounseling ของตัวเอง\nได้ทันที พร้อมความสามารถอีกมากมาย`}
                </Text>
                <StyledFunctionInfoTextGroup>
                    {[
                        'มี feature ด้านสุขภาพจิตที่หลากหลายและง่ายต่อการใช้งาน',
                        'มี dashboard สำหรับจัดการอย่างเป็นระบบ',
                        'ให้คำปรึกษาได้ทั้งแบบเดี่ยวและแบบกลุ่ม',
                        'มีระบบ AI-assisted เพื่อช่วยจดบันทึกและสังเกตอารมณ์',
                        'pay-per-use',
                    ].map((text, index) => (
                        <StyledFunctionInfoTextContainer key={`function-text-${index}`}>
                            <BulletIcon />
                            <Text $fontSize={xlUp ? '18px' : '15px'} $color="black3">
                                {text}
                            </Text>
                        </StyledFunctionInfoTextContainer>
                    ))}
                </StyledFunctionInfoTextGroup>
            </StyledFunctionContainer>
        </StyledFunctionSectionContainer>
    );
};

export const ProfressonalSection = ({ mdUp, lgUp, xlUp }) => {
    return (
        <StyledProfressonalSectionContainer>
            <StyledProfressonalTitleContainer>
                <Text $color="white" $fontSize={xlUp ? '40px' : lgUp ? '30px' : '20px'}>
                    FRIDAY เหมาะกับใคร?
                </Text>
                <Text $color="white" $fontSize={xlUp ? '24px' : lgUp ? '20px' : '15px'}>
                    FRIDAY เหมาะกับคนและองค์กรที่ต้องการ digital transformation
                    ของระบบให้คำปรึกษาและสุขภาพ
                </Text>
            </StyledProfressonalTitleContainer>
            <StyledProfressonalAvatarContainer>
                {[
                    {
                        img: Avatar1,
                        text: 'จิตแพทย์และนักจิตวิทยา',
                    },
                    {
                        img: Avatar2,
                        text: 'คลินิก โรงพยาบาล',
                    },
                    {
                        img: Avatar3,
                        text: 'หน่วยบริการด้านสุขภาพจิต',
                    },
                    {
                        img: Avatar4,
                        text: 'หน่วยให้คำปรึกษาขององค์กร\nบริษัท สถานศึกษา',
                    },
                    {
                        img: Avatar5,
                        text: 'งานบริหารทรัพยากร\nบุคคล (HR)',
                    },
                    {
                        img: Avatar6,
                        text: 'ที่ปรึกษาด้านกฎหมาย\n(Legal consultation)',
                    },
                    {
                        img: Avatar7,
                        text: 'ทุกอาชีพที่ให้บริการทางไกล',
                    },
                ].map((item, index) => (
                    <StyledAvatarContainer key={`avart-${index}`}>
                        <img src={item.img} alt={item.text} />
                        <Text
                            $fontSize={xlUp ? '18px' : lgUp ? '14px' : '10px'}
                            $color="white"
                            style={{ textAlign: 'center', whiteSpace: 'pre-line' }}
                        >
                            {item.text}
                        </Text>
                    </StyledAvatarContainer>
                ))}
            </StyledProfressonalAvatarContainer>
        </StyledProfressonalSectionContainer>
    );
};

export const WhySection = ({ mdUp, lgUp, xlUp }) => {
    return (
        <StyledWhySectionContainer>
            <Text
                $fontSize={xlUp ? '36px' : lgUp ? '30px' : mdUp ? '26px' : '20px'}
                $color="black2"
                $medium
                style={{ textAlign: 'center' }}
            >{`ทำไมจึงควรใช้ FRIDAY เพื่อให้บริการคำปรึกษา และสุขภาพจิตทางไกลของคุณ ?`}</Text>
            <StyledWhyCardContainer>
                {[
                    {
                        img: Icon1,
                        title: 'ระบบของคุณเอง',
                        text: 'เราพัฒนา FRIDAY มาให้พร้อมใช้งานทันที โดยที่คุณ\nไม่จำเป็นต้องสร้างระบบใหม่ทั้งหมดตั้งแต่เริ่มต้น\nซึ่งอาจต้องใช้ระยะเวลายาวนานและมีค่าใช้จ่ายมหาศาล\nในการสร้าง',
                    },
                    {
                        img: Icon2,
                        title: 'พัฒนาอย่างต่อเนื่อง',
                        text: 'เราพัฒนา feature และ ระบบ AI อย่างต่อเนื่อง\nทำให้ FRIDAY ประกอบไปด้วยเทคโนโลยีที่ล้ำหน้า\nตลอดเวลา โดยที่คุณไม่ต้องเสียทรัพยากร\nในการพัฒนาเอง',
                    },
                    {
                        img: Icon3,
                        title: 'ขยายบริการได้ไม่จำกัด',
                        text: 'เราพัฒนา FRIDAY ให้มีความยืดหยุ่นสูง ผู้ให้บริการ\nเดี่ยวหรือหน่วยงานก็ใช้ได้ สามารถให้บริการปรึกษา\nทั้งแบบเดี่ยวหรือกลุ่ม และคุณยังทำการตลาดเพื่อ\nโฆษณาบริการของคุณได้เต็มที่ตามต้องการ',
                    },
                    {
                        img: Icon4,
                        title: 'กำหนดค่าบริการเพื่อตัวคุณ',
                        text: 'เราให้คุณจัดการค่าบริการด้วยตนเอง เนื่องจาก\nเป็นระบบ FRIDAY ของคุณเอง ต่างจากการสมัคร\nเพื่อให้บริการบน Telemedicine อื่น ๆ ซึ่งคุณอาจ\nถูกหักเงินจากค่าบริการในอัตราสูง',
                    },
                    {
                        img: Icon5,
                        title: 'ความปลอดภัยสูงสุด',
                        text: 'เรายึดหลักความปลอดภัยของข้อมูลจากทั้งผู้ให้\nบริการและผู้รับบริการเป็นลำดับแรก\n FRIDAY จึงใช้ระบบในการเก็บรักษาข้อมูลและ\nปกป้องการละเมิดข้อมูลที่มีความสามารถสูงสุด',
                    },
                    {
                        img: Icon6,
                        title: 'ทีมสนับสนุนพร้อมช่วยเหลือ',
                        text: 'เรามีทีมสนับสนุนชั้นยอดที่คอยช่วยเหลือการใช้งาน\nFRIDAY ให้เป็นไปอย่างราบรื่นทั้งผู้ให้บริการและ\nผู้รับบริการ ตั้งแต่เริ่มการใช้บริการจนถึงแก้ไข\nปัญหาต่าง ๆ ที่เกิดขึ้น',
                    },
                ].map((item, index) => (
                    <StyledWhyCard key={`why-${index}`}>
                        <StyledIcon src={item.img} alt={item.title} />
                        <div>
                            <Text
                                $fontSize={xlUp ? '24px' : lgUp ? '22px' : mdUp ? '18px' : '16px'}
                                $color="black4"
                                $medium
                            >
                                {item.title}
                            </Text>
                            <Text
                                $fontSize={xlUp ? '16px' : lgUp ? '14px' : mdUp ? '12px' : '10px'}
                                $color="gray15"
                                style={{ marginTop: lgUp ? '10px' : '5px' }}
                            >
                                {item.text}
                            </Text>
                        </div>
                    </StyledWhyCard>
                ))}
            </StyledWhyCardContainer>
        </StyledWhySectionContainer>
    );
};

export const JoinSection = ({
    // handleToPatient,
    handleToProvider,
    onSelectTab,
    mdUp,
    lgUp,
    xlUp,
}) => {
    return (
        <StyledJoinSectionContainer>
            <StyledJoinTextContainer>
                <Text
                    $fontSize={xlUp ? '40px' : lgUp ? '36px' : mdUp ? '30px' : '25px'}
                    $color="black2"
                    $bold
                >
                    Become a provider!
                </Text>
                <Text
                    $color="gray15"
                    $fontSize={xlUp ? '20px' : lgUp ? '16px' : mdUp ? '12px' : '10px'}
                >{`ให้บริการและผู้รับบริการด้านการปรึกษาและสุขภาพจิต\nให้เข้าใกล้กันมากขึ้น ลดค่าใช้จ่ายและเวลาที่ต้องเสียไป\nสำหรับการเดินทาง ด้วยการบริการผ่านระบบ\nวิดีโอคอลที่ทันสมัย`}</Text>
                <StyledTicketCard>
                    <img src={Ticket} alt="ticket" style={{ width: '32px' }} />
                    <Text $fontSize="14px" $bold>{`Register now`}</Text>
                    <StyledTicketButton
                        // onClick={handleToPatient}
                        // onClick={handleToProvider}
                        onClick={() => onSelectTab(2, 'book-section')}
                    >
                        <Text $fontSize="14px" $color="white" style={{ textTransform: 'none' }}>
                            {`Let's go!`}
                        </Text>
                    </StyledTicketButton>
                </StyledTicketCard>
            </StyledJoinTextContainer>
            <div style={{ display: 'inline-flex' }}>
                <img src={Phone} alt="phone" style={{ width: '100%' }} />
            </div>
        </StyledJoinSectionContainer>
    );
};

JoinSection.propTypes = {
    handleToPatient: PropTypes.func,
    handleToProvider: PropTypes.func,
};

export const StartSectionTwo = ({ handleToProvider, onSelectTab, mdUp, lgUp, xlUp }) => {
    return (
        <StyledStartSectionTwo>
            <StyledMaskContainer>
                <Text
                    $fontSize={xlUp ? '50px' : lgUp ? '40px' : mdUp ? '30px' : '20px'}
                    $color="white"
                    $medium
                    style={{ zIndex: '1', textAlign: 'center' }}
                >{`FRIDAY\nbrings fine days!`}</Text>
                <Text
                    $fontSize={xlUp ? '30px' : lgUp ? '20px' : mdUp ? '16px' : '12px'}
                    $color="white"
                    style={{ zIndex: '1', textAlign: 'center' }}
                >
                    สร้างระบบ Telecounseling ของคุณ
                </Text>
                <BlackButton
                    style={{ marginTop: '15px' }}
                    // onClick={handleToProvider}
                    onClick={() => onSelectTab(2, 'book-section')}
                >
                    <Text
                        $fontSize={mdUp ? '15px' : '12px'}
                        $color="white"
                        style={{ marginRight: '10px' }}
                    >
                        ลงทะเบียนเพื่อทดลองใช้ฟรี
                    </Text>
                </BlackButton>
            </StyledMaskContainer>
        </StyledStartSectionTwo>
    );
};

StartSectionTwo.propTypes = {
    handleToProvider: PropTypes.func,
};

export const Footer = ({ onSelectTab, mdUp, lgUp, xlUp }) => {
    return (
        <StyledFooterContainer>
            <StyledButtonNavContainer>
                <img src={FirdayLogo2} alt="Firday Logo" style={{ margin: 'auto', width: '40px', height: '40px' }} />
                <StyledButtonContainer
                    style={{
                        justifyContent: 'center',
                        // flexDirection: mdUp ? 'row' : 'column',
                        columnGap: xlUp ? '30px' : lgUp ? '25px' : '20px',
                    }}
                >
                    <StyledButton onClick={() => onSelectTab(0, 'info-section')}>
                        <Text $color="black4" $fontSize={lgUp ? '16px' : mdUp ? '14px' : '10px'}>
                            How It Works?
                        </Text>
                    </StyledButton>

                    <StyledButton onClick={() => onSelectTab(1, 'plan-section')}>
                        <Text $color="black4" $fontSize={lgUp ? '16px' : mdUp ? '14px' : '10px'}>
                            Plan & Pricing
                        </Text>
                    </StyledButton>

                    <StyledButton onClick={() => onSelectTab(2, 'book-section')}>
                        <Text $color="black4" $fontSize={lgUp ? '16px' : mdUp ? '14px' : '10px'}>
                            Book a Session
                        </Text>
                    </StyledButton>
                </StyledButtonContainer>
                <StyledButtonContainer style={{ flexDirection: 'column', rowGap: '10px' }}>
                    <StyledButtonContainer
                        style={{
                            justifyContent: mdUp ? 'flex-end' : 'center',
                            columnGap: '10px',
                        }}
                    >
                        <a href="https://lin.ee/yVdzaJV">
                            <IconButton>
                                <LineIcon />
                            </IconButton>
                        </a>
                        <a href="https://www.facebook.com/fridayclinic">
                            <IconButton>
                                <FacebookIcon />
                            </IconButton>
                        </a>
                        <IconButton>
                            <InstagramIcon />
                        </IconButton>
                        <IconButton>
                            <YoutubeIcon />
                        </IconButton>
                    </StyledButtonContainer>
                    <StyledButtonContainer
                        style={{
                            flexDirection: 'column',
                        }}
                    >
                        <StyledButtonContainer>
                            <Text
                                $color="black4"
                                $fontSize={lgUp ? '16px' : mdUp ? '14px' : '10px'}
                            >
                                Phone:
                            </Text>
                            <a
                                href="tel:0801915777"
                                style={{ textDecoration: 'none', marginLeft: '5px' }}
                            >
                                <Text
                                    $color="black4"
                                    $fontSize={lgUp ? '16px' : mdUp ? '14px' : '10px'}
                                >
                                    080-191-5777
                                </Text>
                            </a>
                        </StyledButtonContainer>
                        <StyledButtonContainer>
                            <Text
                                $color="black4"
                                $fontSize={lgUp ? '16px' : mdUp ? '14px' : '10px'}
                            >
                                Email:
                            </Text>
                            <a
                                href="mailto:team@fridayclinic.com"
                                style={{ textDecoration: 'none', marginLeft: '5px' }}
                            >
                                <Text
                                    $color="black4"
                                    $fontSize={lgUp ? '16px' : mdUp ? '14px' : '10px'}
                                >
                                    team@fridayclinic.com
                                </Text>
                            </a>
                        </StyledButtonContainer>
                    </StyledButtonContainer>
                </StyledButtonContainer>
            </StyledButtonNavContainer>
            <HorizontalRule
                style={{
                    width: '80%',
                    margin: xlUp
                        ? '40px auto 30px'
                        : lgUp
                        ? '35px auto 25px'
                        : mdUp
                        ? '30px auto 20px'
                        : '15px auto',
                }}
            />
            <Text $fontSize="11px" style={{ color: '#959595', textAlign: 'center' }}>
                Copyright © 2022 Friday
            </Text>
        </StyledFooterContainer>
    );
};

Footer.propTypes = {
    onSelectTab: PropTypes.func,
};

const CardItem = ({ data, mdUp, lgUp, xlUp }) => {
    return (
        <StyledCardItem>
            {data.title && (
                <Text
                    $fontSize={xlUp ? '20px' : lgUp ? '18px' : '16px'}
                    $color="white"
                    $bold
                    style={{ textTransform: 'uppercase' }}
                >
                    {data.title}
                </Text>
            )}
            <Text $fontSize={xlUp ? '20px' : lgUp ? '18px' : '16px'} $color="white">
                {data.time}
            </Text>
            <Text $fontSize={xlUp ? '64px' : lgUp ? '54px' : '44px'} $color="white" $bold>
                <Span $fontSize={xlUp ? '36px' : lgUp ? '30px' : '25px'}>฿</Span>
                {`${data.price}`}
            </Text>
            {data.extra && (
                <Text $fontSize="12px" $color="gray16">
                    {`+ ${data.extra} baht per minutes`}
                </Text>
            )}
        </StyledCardItem>
    );
};

CardItem.propTypes = {
    data: PropTypes.object,
};

const PlanCard = ({ data, onClick, mdUp, lgUp, xlUp }) => {
    return (
        <StyledPlanCard>
            <Text $fontSize="32px" $color="white" $bold>
                {data.name}
            </Text>
            <CardItemContainer>
                {data.items.map((item, index) => (
                    <CardItem key={`item-${index}`} data={item} />
                ))}
            </CardItemContainer>

            <StyledPlanButton onClick={onClick}>Select</StyledPlanButton>
        </StyledPlanCard>
    );
};

PlanCard.propTypes = {
    data: PropTypes.object,
    onClick: PropTypes.func,
};

export const PlanSection = ({ handleToProvider, mdUp, lgUp, xlUp }) => {
    const handleSelectPlan = () => {
        handleToProvider();
    };

    return (
        <StyledPlanSectionContainer id="plan-section">
            <HalfBackground />
            <TitleGradient
                style={{ marginBottom: xlUp ? '50px' : lgUp ? '40px' : mdUp ? '30px' : '20px' }}
            >
                Plan & Pricing
            </TitleGradient>
            <StyledPlanCardContainer>
                {[
                    {
                        name: 'Individual',
                        items: [
                            { time: '30 minutes', price: '100', extra: '2' },
                            { time: '1 hour', price: '160' },
                        ],
                    },
                    {
                        name: 'Group',
                        items: [
                            {
                                title: '2nd-3rd client',
                                time: '30 minutes',
                                price: '90',
                                extra: '2',
                            },
                            {
                                title: '4th-6th client',
                                time: '30 minutes',
                                price: '80',
                                extra: '2',
                            },
                        ],
                    },
                ].map((item, index) => (
                    <PlanCard key={`plan-${index}`} data={item} onClick={handleSelectPlan} />
                ))}
            </StyledPlanCardContainer>
        </StyledPlanSectionContainer>
    );
};

PlanSection.propTypes = {
    handleToProvider: PropTypes.func,
};

export const CommingSoonSection = ({ onSelectTab, mdUp, lgUp, xlUp }) => {
    const params = new URLSearchParams(window.location.search);
    const language = params.get('language');
    return (
        <StyledPlanSectionContainer id="plan-section">
            <HalfBackground />
            <div
                style={{
                    zIndex: '1',
                    textAlign: 'center',
                    height: lgUp ? '350px' : mdUp ? '450px' : '450px',
                    marginTop: '40px'
                }}
            >
                <img
                    src={commingsoonImage}
                    alt="commingsoonImage"
                    style={{ width: lgUp ? '250px' : mdUp ? '300px' : '300px', marginBottom: 20 }}
                />
                <Text $color="black4" $fontSize="20px">
                    {language == 'th' ? 'เตรียมพบกันเร็ว ๆ นี้!' : 'Coming soon!'}
                </Text>
                <Text $color="gray16" $fontSize="14px" style={{ fontWeight: '400', marginTop: 15 }}>
                    {language == 'th'
                        ? 'เราจะกลับมาเร็ว ๆ นี้เพื่อสิ่งที่ดีกว่าเดิม'
                        : 'We will be back soon'}
                </Text>
                <Text $color="gray16" $fontSize="14px" style={{ fontWeight: '400', marginTop: 10 }}>
                    {language == 'th' ? 'บนแพลตฟอร์มฟรายเดย์' : 'for more on Friday'}
                </Text>
                <div
                    style={{
                        border: '1px solid #C7C9D9',
                        borderRadius: '50px',
                        backgroundColor: 'transparent',
                        padding: '7px',
                        marginTop: '30px',
                        cursor: 'pointer',
                    }}
                    onClick={() => onSelectTab(0)}
                >
                    <Text $color="gray17" $fontSize="14px" style={{ fontWeight: '400' }}>
                        
                        {language == 'th' ? 'กลับไปหน้าแรก' : 'Back to Home'}
                    </Text>
                </div>
            </div>
        </StyledPlanSectionContainer>
    );
};

CommingSoonSection.propTypes = {};

const Input = ({
    name,
    onChange,
    value,
    error,
    icon,
    placeholder,
    InputProps,
    disabled,
    ...rest
}) => {
    return (
        <FormControl variant="filled" style={{ width: '100%' }}>
            <StyledInput
                id={`input-${name}`}
                name={name}
                value={value}
                placeholder={placeholder}
                onChange={onChange}
                InputProps={{
                    disableUnderline: true,
                    endAdornment: icon && <InputAdornment position="end">{icon}</InputAdornment>,
                    ...InputProps,
                }}
                disabled={disabled}
                error={error}
                {...rest}
            />
        </FormControl>
    );
};

Input.propTypes = {
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.bool,
    icon: PropTypes.node,
    placeholder: PropTypes.string,
    InputProps: PropTypes.object,
    disabled: PropTypes.bool,
    rest: PropTypes.object,
};

export const KeyboardDatePicker = ({ error, onChange, disabled, ...rest }) => {
    return (
        <StyledKeyboardDatePicker
            disablePast
            autoOk
            variant="inline"
            inputVariant="outlined"
            format="DD/MM/YYYY"
            placeholder="Select Date"
            InputAdornmentProps={{ position: 'end' }}
            keyboardIcon={<CalendarIcon2 fill="blue1" width="26" height="26" />}
            onChange={(date) => onChange(date)}
            disabled={disabled}
            error={error}
            {...rest}
        />
    );
};

KeyboardDatePicker.propTypes = {
    error: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    rest: PropTypes.object,
};

const TimePicker = ({ value, onChange, error, disabled }) => {
    const [open, setOpen] = useState(false);
    const [time, setTime] = useState('');

    const onTimeChange = (time) => {
        const formatted = time.format('HH:mm');
        setTime(formatted);
        onChange(formatted);
    };

    useEffect(() => {
        setTime(value);
    }, [value]);

    return (
        <div style={{ position: 'relative', width: '100%' }}>
            <Input
                id="time"
                name="time"
                placeholder="Select"
                value={time}
                onChange={() => {}}
                error={error}
                onFocus={() => setOpen(true)}
                icon={
                    <IconButton
                        style={{
                            height: 'auto',
                            width: 'auto',
                            padding: '10px',
                            marginRight: '-10px',
                        }}
                        onClick={() => setOpen(true)}
                        disabled={disabled}
                    >
                        <TimeIcon fill="blue1" />
                    </IconButton>
                }
                disabled={disabled}
            />

            <StyledTimePicker
                open={open}
                style={{
                    visibility: 'hidden',
                    position: 'absolute',
                    left: 0,
                    top: 0,
                }}
                popupStyle={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    zIndex: 1300,
                }}
                showSecond={false}
                onChange={onTimeChange}
                onClose={() => setOpen(false)}
                focusOnOpen
            />
        </div>
    );
};

TimePicker.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    error: PropTypes.bool,
    disabled: PropTypes.bool,
};

export const BookSection = ({
    loading,
    inputValue,
    handleChange,
    handleDateChange,
    handleTimeChange,
    errors,
    onSubmit,
    selectedTab,
    // handleToProvider,
    setSelectedTab,
    mdUp,
    lgUp,
    xlUp,
}) => {
    const formRef = useRef(null);
    const [containerHeight, setContainerHeight] = useState('700px');

    const handleResize = () => {
        if (formRef.current) {
            setContainerHeight(`${formRef.current.offsetHeight}px`);
        }
    };

    window.addEventListener('resize', handleResize);

    return (
        <StyledBookSectionContainer id="book-section">
            <HalfBackground />
            <TitleGradient style={{ marginBottom: xlUp ? '50px' : lgUp ? '40px' : '30px' }}>
                {`Let's talk`}
            </TitleGradient>
            {selectedTab === 2 && (
                <StyledBookFormCard ref={formRef}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            marginBottom: mdUp ? '30px' : '15px',
                        }}
                    >
                        <Text $fontSize={lgUp ? '24px' : mdUp ? '20px' : '16px'} $color="black4">
                            Book a private Q&A session with us
                        </Text>
                        <Text $fontSize={lgUp ? '16px' : mdUp ? '12px' : '10px'} $color="gray16">
                            We would love to hear from you. Please complete this form.
                        </Text>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            rowGap: mdUp ? '20px' : '15px',
                            marginBottom: '30px',
                        }}
                    >
                        <Input
                            id="fullname"
                            name="fullname"
                            placeholder="Full name"
                            value={inputValue?.fullname}
                            onChange={handleChange}
                            error={
                                errors.find((error) => error.property === 'fullname') ? true : false
                            }
                            disabled={loading}
                            max={50}
                        />

                        <Input
                            id="phoneNumber"
                            name="phoneNumber"
                            placeholder="Phone Number"
                            value={inputValue?.phoneNumber}
                            onChange={handleChange}
                            error={
                                errors.find((error) => error.property === 'phoneNumber')
                                    ? true
                                    : false
                            }
                            icon={<CallIcon />}
                            InputProps={{
                                inputComponent: PhoneFormat,
                            }}
                            disabled={loading}
                        />
                        <Input
                            name="email"
                            placeholder="Email"
                            value={inputValue?.email}
                            onChange={handleChange}
                            error={
                                errors.find((error) => error.property === 'email') ? true : false
                            }
                            icon={<SMSIcon />}
                            disabled={loading}
                            max={30}
                        />
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            marginBottom: mdUp ? '20px' : '15px',
                        }}
                    >
                        <Text $fontSize={lgUp ? '20px' : mdUp ? '16px' : '12px'} $color="black4">
                            Pick a date
                        </Text>
                        <Text $fontSize={lgUp ? '14px' : mdUp ? '12px' : '10px'} $color="gray16">
                            We would love to show you the incredible session creation. Please let us
                            know when you are available and we will make our best to receive you on
                            that date and time.
                        </Text>
                    </div>
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: mdUp ? '1fr 1fr' : '1fr',
                            columnGap: '15px',
                            rowGap: mdUp ? '20px' : '15px',
                            marginBottom: mdUp ? '35px' : '20px',
                        }}
                    >
                        <KeyboardDatePicker
                            id="date"
                            value={inputValue.date}
                            onChange={handleDateChange}
                            error={errors.find((error) => error.property === 'date') ? true : false}
                            disabled={loading}
                        />
                        <TimePicker
                            value={inputValue.time}
                            onChange={handleTimeChange}
                            error={errors.find((error) => error.property === 'time') ? true : false}
                            disabled={loading}
                        />
                    </div>
                    <ContainedButton
                        $backgroundColor="blue12"
                        $height={lgUp ? '58px' : mdUp ? '50px' : '40px'}
                        style={{ borderRadius: '30px' }}
                        onClick={onSubmit}
                        loading={loading}
                    >
                        BOOK A SESSION
                    </ContainedButton>
                </StyledBookFormCard>
            )}
            {selectedTab === 3 && (
                <StyledBookSuccessContainer style={{ height: containerHeight }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginTop: mdUp ? '100px' : '50px',
                            marginBottom: mdUp ? '100px' : '50px',
                        }}
                    >
                        <Text
                            $fontSize={mdUp ? '24px' : '20px'}
                            $color="black4"
                            $bold
                            style={{ textAlign: 'center' }}
                        >
                            Thank you, we heard you already!
                        </Text>
                        <Text
                            $fontSize={mdUp ? '16px' : '12px'}
                            $color="gray16"
                            style={{ textAlign: 'center' }}
                        >
                            {`We're excited for you to reach your network growing up with us. Now,
                            let's FRIDAY team contacting you back.`}
                        </Text>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            rowGap: '20px',
                        }}
                    >
                        {/* <StyledTicketButton
                            style={{
                                borderRadius: '34px',
                                width: '359px',
                                height: '58px',
                                color: 'white',
                            }}
                            onClick={handleToProvider}
                        >
                            Let’s try for FREE!
                        </StyledTicketButton> */}
                        <OutlinedButton
                            $color="gray17"
                            style={{
                                borderRadius: '34px',
                                width: mdUp ? '359px' : '280px',
                                height: mdUp ? '58px' : '50px',
                            }}
                            onClick={() => setSelectedTab(0)}
                        >
                            Back to Home
                        </OutlinedButton>
                    </div>
                </StyledBookSuccessContainer>
            )}
        </StyledBookSectionContainer>
    );
};

BookSection.propTypes = {
    loading: PropTypes.bool,
    inputValue: PropTypes.object,
    handleChange: PropTypes.func,
    handleDateChange: PropTypes.func,
    handleTimeChange: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.object),
    onSubmit: PropTypes.func,
    selectedTab: PropTypes.number,
    handleToProvider: PropTypes.func,
    setSelectedTab: PropTypes.func,
};
